import awsdk from 'awsdk';

export const EligibilitySuggestedResponse = awsdk.AWSDKEligibilitySuggestedResponse;
export type EligibilitySuggestedResponse = typeof EligibilitySuggestedResponse;
